export enum SpecialReportsDateBlock {
  Root = 'SpecialReportsDate',
}

export enum SpecialReportsDateCellElement {
  Date = 'date',
}
